import { createFileRoute } from '@tanstack/react-router';
import { OrganizationBilling } from '@uturn/portal/modules/org/pages/billing';

export const Route = createFileRoute('/_protected/org/$orgId/settings/billing')(
	{
		component: OrganizationBilling,
	},
);
